"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuidV4Regex = exports.normalizePath = exports.path = void 0;
const path_to_regexp_1 = require("path-to-regexp");
/**
 * Create a path object.
 * @param pattern A pattern to match a path against
 *
 * @example
 * const accountsPath = path("/accounts");
 * accountsPath.pattern // "/accounts"
 * accountsPath()       // "/accounts"
 *
 * const accountPath = accountsPath.slash(":accountId");
 * accountPath.pattern               // "/accounts/:accountId"
 * accountPath({ accountId: "123" }) // "/accounts/123"
 */
const path = (pattern) => {
    return Object.assign((0, path_to_regexp_1.compile)(pattern), {
        pattern,
        slash: (subPattern) => {
            const parent = (pattern === "/" ? "" : pattern);
            return (0, exports.path)(`${parent}/${subPattern}`);
        },
        regex: (options) => (0, path_to_regexp_1.pathToRegexp)(pattern, [], options),
        match: (pathname, options) => (0, path_to_regexp_1.match)(pattern, options)(pathname)
    });
};
exports.path = path;
/**
 * Normalizes a provided path by replacing multiple consecutive slashes with a single slash.
 * Note that this should be used with paths only and not full URLs.
 *
 * @param path A path to normalize
 *
 * @example
 * normalizePath("//accounts/acc123///videos") // "/accounts/acc123/videos"
 */
const normalizePath = (path) => path.replace(/\/+/g, "/");
exports.normalizePath = normalizePath;
// Adapted from this answer: https://stackoverflow.com/a/18516125
exports.uuidV4Regex = "[a-fA-F0-9]{8}-?[a-fA-F0-9]{4}-?4[a-fA-F0-9]{3}-?[89abAB][a-fA-F0-9]{3}-?[a-fA-F0-9]{12}";
//# sourceMappingURL=utils.js.map